export default __webpack_public_path__ + "static/media/1908.121a7628.png";